export default __webpack_public_path__ + "static/media/students.8bbccd09.svg";